import { createLocalStorageProvider } from '@atlassian/jira-browser-storage-providers/src/controllers/local-storage/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

// TODO : Add a prefix to identify each app and also make sure you update the same in test
const localStorageProvider = createLocalStorageProvider('');

const HIDE_EPIC_FIELD_PREFIX = 'gh.epicShownOnRapidBoard.';
const HIDE_STATUS_FIELD_PREFIX = 'gh.statusShownOnRapidBoard.';
const HIDE_VERSION_FIELD_PREFIX = 'gh.versionShownOnRapidBoard.';

export const getHideEpics = (boardId: string | number): boolean =>
	(fg('jfp-vulcan-browser-storage-migration')
		? localStorageProvider.get(`${HIDE_EPIC_FIELD_PREFIX}${boardId}`)
		: localStorage.getItem(`${HIDE_EPIC_FIELD_PREFIX}${boardId}`)) === 'false';

export const setHideEpics = (boardId: string | number, hideEpics: boolean) =>
	fg('jfp-vulcan-browser-storage-migration')
		? localStorageProvider.set(`${HIDE_EPIC_FIELD_PREFIX}${boardId}`, (!hideEpics).toString())
		: localStorage.setItem(`${HIDE_EPIC_FIELD_PREFIX}${boardId}`, (!hideEpics).toString());

export const getHideStatuses = (boardId: string | number): boolean =>
	(fg('jfp-vulcan-browser-storage-migration')
		? localStorageProvider.get(`${HIDE_STATUS_FIELD_PREFIX}${boardId}`)
		: localStorage.getItem(`${HIDE_STATUS_FIELD_PREFIX}${boardId}`)) === 'false';

export const setHideStatuses = (boardId: string | number, hideStatuses: boolean) =>
	fg('jfp-vulcan-browser-storage-migration')
		? localStorageProvider.set(`${HIDE_STATUS_FIELD_PREFIX}${boardId}`, (!hideStatuses).toString())
		: localStorage.setItem(`${HIDE_STATUS_FIELD_PREFIX}${boardId}`, (!hideStatuses).toString());

export const getHideVersions = (boardId: string | number): boolean =>
	(fg('jfp-vulcan-browser-storage-migration')
		? localStorageProvider.get(`${HIDE_VERSION_FIELD_PREFIX}${boardId}`)
		: localStorage.getItem(`${HIDE_VERSION_FIELD_PREFIX}${boardId}`)) === 'false';

export const setHideVersions = (boardId: string | number, hideVersions: boolean) =>
	fg('jfp-vulcan-browser-storage-migration')
		? localStorageProvider.set(`${HIDE_VERSION_FIELD_PREFIX}${boardId}`, (!hideVersions).toString())
		: localStorage.setItem(`${HIDE_VERSION_FIELD_PREFIX}${boardId}`, (!hideVersions).toString());
